import React from "react";
import {
  DialogActions,
  DialogContentText,
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { reset2FA } from "../../slices/operaters";
import {
  enqueueSnackbar as enqueueSnackbarAction,
  closeSnackbar as closeSnackbarAction,
} from "../../slices/notifier";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";

const Reset2FAModal = ({ id, open, handleClose, data }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { statusReset2FA } = useSelector((state) => state.operators);
  const enqueueSnackbar = (...args) => dispatch(enqueueSnackbarAction(...args));
  const closeSnackbar = (...args) => dispatch(closeSnackbarAction(...args));
  const showSnackbar = (snack) => {
    enqueueSnackbar({
      message: t(snack.message),
      options: {
        key: new Date().getTime() + Math.random(),
        variant: snack.variant,
        action: (key) => (
          <Button style={{ color: "#fff" }} onClick={() => closeSnackbar(key)}>
            {t("dismiss me")}
          </Button>
        ),
      },
    });
  };

  const handleReset2FA = () => {
    dispatch(
      reset2FA({
        operatorId: data?.operatorId,
        websiteID: data?.websiteId,
      })
    ).then((res) => {
      !res?.error
        ? showSnackbar({
            message:
              res?.payload?.message ||
              t("Two-factor authentication reset successfully"),
            variant: "success",
          })
        : showSnackbar({
            message: res?.error?.message || t("Something went wrong"),
            variant: "error",
          });
      handleClose(id);
    });
  };

  return (
    <Dialog open={open} onClose={() => handleClose(id)} className="info-modal">
      <LazyLoadImage
        src={data?.icon}
        className="assign-icon"
        alt="reset-2fa-icon"
      />
      <DialogTitle className="assign-operator-title">{data?.title}</DialogTitle>
      <DialogContent>
        <DialogContentText className="assign-operator-text">
          {data?.description}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="assign-operator-btns">
        <Button
          className="assign-operator-cancel-btn"
          onClick={() => handleClose(id)}
        >
          {t("Cancel")}
        </Button>
        <Button
          className="delete-message-btn"
          disabled={statusReset2FA === "loading"}
          onClick={handleReset2FA}
        >
          {statusReset2FA === "loading" ? (
            <CircularProgress className="circular-progress-delete-modal" />
          ) : (
            t("Reset 2FA")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Reset2FAModal;
